import { render, staticRenderFns } from "./ChronicDiseaseTeam.vue?vue&type=template&id=d92ccb7e&scoped=true&"
import script from "./ChronicDiseaseTeam.vue?vue&type=script&lang=js&"
export * from "./ChronicDiseaseTeam.vue?vue&type=script&lang=js&"
import style0 from "./ChronicDiseaseTeam.vue?vue&type=style&index=0&id=d92ccb7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92ccb7e",
  null
  
)

export default component.exports